import { Pipe, PipeTransform } from "@angular/core";
import { DoctorService } from "src/app/services/doctor.service";
import { formatDabadocTime } from "src/app/helpers/dabadoc-time.helper";

/** "dd/MM/yyyy" of a DabaDoc time, exactly as the API wrote it (no timezone conversion). */
@Pipe({
  standalone: true, name: "customDate" })
export class CustomDatePipe implements PipeTransform {
  locale: string = "fr";
  constructor(private doctorService: DoctorService) {}

  transform(date: any): any {
    if (this.doctorService.current) {
      this.locale = this.doctorService.current.locale;
    }
    return formatDabadocTime(date, "dd/MM/yyyy", this.locale);
  }
}
